const initState={};

const CodesDropDownReducer = (state = initState, action) => {
    switch(action.type) {
        case  'CodesDropDown' : return  action.payload;
        default: return state;
    }
}
export default CodesDropDownReducer;